import { render, staticRenderFns } from "./pbi-gm-dnc-s10-study.page.vue?vue&type=template&id=67c29fb6"
import script from "./pbi-gm-dnc-s10-study.page.vue?vue&type=script&lang=ts"
export * from "./pbi-gm-dnc-s10-study.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports